export default __webpack_public_path__ + "static/banner-627fb2038be96fcaa29ad077d99a8324.png";